import React,{Component} from 'react';
import $ from 'jquery';
import './content-right-price.css';
import currency_schema from '../../../../service/schema/currency-scema';
import config from '../../../../config';


class ContentRightPrice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            price:{}
        }
        this.state =   config.data;
    }

    // static getPriceConvert(param) {
    //
    //     const cur_tp = param.toUpperCase();
    //
    //     if(cur_tp === 'USD') {
    //         $('#smprice').html("$ " + config.price.price.single);
    //         $('#tmprice').html("$ " + config.price.price.team);
    //         $('#cmprice').html("$ " + config.price.price.corporate);
    //
    //         $('#rep_sin').html("$ " + config.price.price.single);
    //         $('#rep_team').html("$ " + config.price.price.team);
    //         $('#rep_corp').html("$ " + config.price.price.corporate);
    //
    //
    //         $('#rp').html("$ " + config.price.price.single);
    //         $('#latestprice').html(config.price.price.single);
    //
    //     } else if (cur_tp === 'INR') {
    //
    //         config.data.price.single = (parseFloat(config.price.price.single) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;
    //         config.data.price.team = (parseFloat(config.price.price.team) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;
    //         config.data.price.corporate = (parseFloat(config.price.price.corporate) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;
    //
    //         $('#rep_sin').html("₹ " + config.price.price.single);
    //         $('#rep_team').html("₹ " + config.price.price.team);
    //         $('#rep_corp').html("₹ " + config.price.price.corporate);
    //
    //         $('#smprice').html("₹ " + config.data.price.single);
    //         $('#tmprice').html("₹ " + config.data.price.team);
    //         $('#cmprice').html("₹ " + config.data.price.corporate);
    //
    //         $('#rp').html("₹ " + config.data.price.single);
    //         $('#latestprice').html(config.data.price.single);
    //
    //     }  else if (cur_tp === 'EUR') {
    //
    //         config.data.price.single = (parseFloat(config.price.price.single) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;
    //         config.data.price.team = (parseFloat(config.price.price.team) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;
    //         config.data.price.corporate = (parseFloat(config.price.price.corporate) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;
    //
    //
    //         $('#smprice').html("€ " + config.data.price.single);
    //         $('#tmprice').html("€ " + config.data.price.team);
    //         $('#cmprice').html("€ " + config.data.price.corporate);
    //
    //         $('#rep_sin').html("€ " + config.price.price.single);
    //         $('#rep_team').html("€ " + config.price.price.team);
    //         $('#rep_corp').html("€ " + config.price.price.corporate);
    //
    //         $('#rp').html("€ " + config.data.price.single);
    //         $('#latestprice').html(config.data.price.single);
    //
    //     } else if (cur_tp === 'JPY') {
    //
    //         config.data.price.single = (parseFloat(config.price.price.single) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;
    //         config.data.price.team = (parseFloat(config.price.price.team) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;
    //         config.data.price.corporate = (parseFloat(config.price.price.corporate) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;
    //
    //
    //         $('#smprice').html("¥ " + config.data.price.single);
    //         $('#tmprice').html("¥ " + config.data.price.team);
    //         $('#cmprice').html("¥ " + config.data.price.corporate);
    //
    //         $('#rep_sin').html("¥ " + config.price.price.single);
    //         $('#rep_team').html("¥ " + config.price.price.team);
    //         $('#rep_corp').html("¥ " + config.price.price.corporate);
    //
    //         $('#rp').html("¥ " + config.data.price.single);
    //         $('#latestprice').html(config.data.price.single);
    //
    //     } else if (cur_tp === 'GBP') {
    //
    //         config.data.price.single = (parseFloat(config.price.price.single) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;
    //         config.data.price.team = (parseFloat(config.price.price.team) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;
    //         config.data.price.corporate = (parseFloat(config.price.price.corporate) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;
    //
    //
    //         $('#smprice').html("£ " + config.data.price.single);
    //         $('#tmprice').html("£ " + config.data.price.team);
    //         $('#cmprice').html("£ " + config.data.price.corporate);
    //
    //         $('#rep_sin').html("£ " + config.price.price.single);
    //         $('#rep_team').html("£ " + config.price.price.team);
    //         $('#rep_corp').html("£ " + config.price.price.corporate);
    //
    //         $('#rp').html("£ " + config.data.price.single);
    //         $('#latestprice').html(config.data.price.single);
    //
    //     }
    //     $( ".p-select1" ).trigger( "click" );
    //     console.log('Data f',config)
    //     localStorage.setItem('latest_cuurency',param);
    //
    // }

    updateData() {

        this.setState({price: this.state.price})
    }
    static getPriceConvert(param) {

        const cur_tp = param.toUpperCase();

        if(cur_tp === 'USD') {
            $('#smprice').html("$ " + config.price.price.single);
            $('#tmprice').html("$ " + config.price.price.team);
            $('#cmprice').html("$ " + config.price.price.corporate);

            $('#rep_sin').html("$ " + config.price.price.single);
            $('#rep_team').html("$ " + config.price.price.team);
            $('#rep_corp').html("$ " + config.price.price.corporate);


            $('#rp').html("$ " + config.price.price.single);
            $('#latestprice').html(config.price.price.single);

        } else if (cur_tp === 'INR') {

            config.data.price.single = (parseFloat(config.price.price.single) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;
            config.data.price.team = (parseFloat(config.price.price.team) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;
            config.data.price.corporate = (parseFloat(config.price.price.corporate) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;

            $('#rep_sin').html("₹ " + config.price.price.single);
            $('#rep_team').html("₹ " + config.price.price.team);
            $('#rep_corp').html("₹ " + config.price.price.corporate);

            $('#smprice').html("₹ " + config.data.price.single);
            $('#tmprice').html("₹ " + config.data.price.team);
            $('#cmprice').html("₹ " + config.data.price.corporate);

            $('#rp').html("₹ " + config.data.price.single);
            $('#latestprice').html(config.data.price.single);

        }  else if (cur_tp === 'EUR') {

            config.data.price.single = (parseFloat(config.price.price.single) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;
            config.data.price.team = (parseFloat(config.price.price.team) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;
            config.data.price.corporate = (parseFloat(config.price.price.corporate) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;


            $('#smprice').html("€ " + config.data.price.single);
            $('#tmprice').html("€ " + config.data.price.team);
            $('#cmprice').html("€ " + config.data.price.corporate);

            $('#rep_sin').html("€ " + config.price.price.single);
            $('#rep_team').html("€ " + config.price.price.team);
            $('#rep_corp').html("€ " + config.price.price.corporate);

            $('#rp').html("€ " + config.data.price.single);
            $('#latestprice').html(config.data.price.single);

        } else if (cur_tp === 'JPY') {

            config.data.price.single = (parseFloat(config.price.price.single) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;
            config.data.price.team = (parseFloat(config.price.price.team) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;
            config.data.price.corporate = (parseFloat(config.price.price.corporate) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;


            $('#smprice').html("¥ " + config.data.price.single);
            $('#tmprice').html("¥ " + config.data.price.team);
            $('#cmprice').html("¥ " + config.data.price.corporate);

            $('#rep_sin').html("¥ " + config.price.price.single);
            $('#rep_team').html("¥ " + config.price.price.team);
            $('#rep_corp').html("¥ " + config.price.price.corporate);

            $('#rp').html("¥ " + config.data.price.single);
            $('#latestprice').html(config.data.price.single);

        } else if (cur_tp === 'GBP') {

            config.data.price.single = (parseFloat(config.price.price.single) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;
            config.data.price.team = (parseFloat(config.price.price.team) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;
            config.data.price.corporate = (parseFloat(config.price.price.corporate) * parseFloat(currency_schema.data.rates[cur_tp])).toFixed(2) ;


            $('#smprice').html("£ " + config.data.price.single);
            $('#tmprice').html("£ " + config.data.price.team);
            $('#cmprice').html("£ " + config.data.price.corporate);

            $('#rep_sin').html("£ " + config.price.price.single);
            $('#rep_team').html("£ " + config.price.price.team);
            $('#rep_corp').html("£ " + config.price.price.corporate);

            $('#rp').html("£ " + config.data.price.single);
            $('#latestprice').html(config.data.price.single);

        }
        $( ".p-select1" ).trigger( "click" );
        console.log('Data f',config)
        localStorage.setItem('latest_cuurency',param);



    }
    render() {
        console.log('render part1',this.state)
        this.state = config.data;
        const  isLoading  = config.data.price.single == undefined ? true : false;

        return(
            <div id="omk">
                <div class="lic"> <span>Purchase Report</span> </div>
                <div class="slct_price">
                    <div class="p-select1" data-toggle="tooltip" title="Single User Licence - For use by 1 person only. Report will be delivered in PDF format within 24-48 hrs of purchase. This helps us to ensure the latest developments in the market are included.">
                        <div class="s_icons"> <i class="fa fa-dot-circle-o"></i> </div>
                        <div class="re-s-price"> <span class="rep_sin" id="smprice">$ {config.data.price.single}  </span>

                            <br /><span class="rep-s-type">Single user license</span> </div>
                    </div>
                    <div class="p-select2" data-toggle="tooltip" title="Team Licence - For use by a team of upto 7 members. Report will be delivered in PDF format within 24-48 hrs of purchase. This helps us to ensure the latest developments in the market are included.">
                        <div class="t_icons"> <i class="fa fa-circle-o"></i> </div>
                        <div class="re-t-price"> <span class="rep_team" id="tmprice">$ {config.data.price.team}</span>

                            <br /><span class="rep-t-type">Team license</span> </div>
                    </div>
                    <div class="p-select3" data-toggle="tooltip" title="Corporate Licence - For use by all the employees within your organisation. Report will be delivered in PDF format within 24-48 hrs of purchase. This helps us to ensure the latest developments in the market are included.">
                        <div class="c_icons"> <i class="fa fa-circle-o"></i> </div>
                        <div class="re-c-price"> <span class="rep_corp" id="cmprice">$ {config.data.price.corporate} </span>
                            <br /><span class="rep-c-type">Corporate license</span> </div>
                    </div>
                    <form>
                                            <input type="hidden" name="re_id" id="re_id" value={config.data.id} />
                                            <input type="hidden" name="re_type" id="re_type" value="Single User Licence" />
                                            <input type="hidden" name="re_title" id="re_title" value="Global Biologics Market - Segmented by Product, and Applications - Growth, Trends and Forecasts (2018 - 2023)" />
                                            <input type="hidden" name="single" id="single" value={config.data.price.single} />
                                            <input type="hidden" name="team" id="team" value="4500"/>

                                            <input type="hidden" name="corporate" id="corporate" value="8750" />
                                            <input type="hidden" name="usd" id="usd" value="1" />
                                            <input type="hidden" name="inr" id="inr" value="63.619999" />
                                            <input type="hidden" name="eur" id="eur" value="0.8431" />
                                            <input type="hidden" name="jpy" id="jpy" value="110.710999" />
                                            <input type="hidden" name="gbp" id="gbp" value="0.75614" />
                    </form>
                </div>
                <div>

                    <button class="customButton customButton_style" disabled={isLoading} > <i class="fa fa-shopping-cart ccart"></i> Buy Now - <span class="rep_sin" id="rp">$ {config.data.price.single}</span>
                        <span class="latestprice hide" id="latestprice">{config.data.price.single}</span><span class="latestpricelogo hide" id="latestpricelogo">$</span> </button>

                </div>
            </div>
        )
    }
    shouldComponentUpdate(nextProps, nextState) {
        console.log(nextProps, nextState);
        console.log(this.props, this.state);
        this.render();
        return true;
    }
    onload() {
        $(document).ready(function(){
            // $('[data-toggle="tooltip"]').tooltip();
            localStorage.setItem("payment_type","single")
            $('.p-select1').click(function(){
                $('.s_icons').html('<i class="fa fa-dot-circle-o"></i>');
                $('.t_icons').html('<i class="fa fa-circle-o"></i>');
                $('.c_icons').html('<i class="fa fa-circle-o"></i>');
                $('.v2').text(' - '+' Single user license');
                $('#re_type').val('Single user license');
                var sprice=$('#smprice').text();

                $('#rp').html(sprice);
                $('#rpm').html(sprice);
                var price=sprice.substring(2,sprice.length);
                var pricelogo=sprice.substring(0,1);
                $('#latestprice').html(price);
                $('#latestpricelogo').html(pricelogo);
                localStorage.setItem("payment_type","single")
            });

            $('.p-select2').click(function(){
                $('.s_icons').html('<i class="fa fa-circle-o"></i>');
                $('.t_icons').html('<i class="fa fa-dot-circle-o"></i>');
                $('.c_icons').html('<i class="fa fa-circle-o"></i>');
                $('.v2').text(' - '+' Team license');
                $('#re_type').val('Team license');
                var tprice=$('#tmprice').text();

                $('#rp').html(tprice);
                $('#rpm').html(tprice);
                var price=tprice.substring(2,tprice.length);
                var pricelogo=tprice.substring(0,1);
                $('#latestprice').html(price);
                $('#latestpricelogo').html(pricelogo);
                localStorage.setItem("payment_type","team")
            });


            $('.p-select3').click(function(){
                $('.s_icons').html('<i class="fa fa-circle-o"></i>');
                $('.t_icons').html('<i class="fa fa-circle-o"></i>');
                $('.c_icons').html('<i class="fa fa-dot-circle-o"></i>');
                $('.v2').text(' - '+' Corporate license');
                $('#re_type').val('Corporate license');
                var cprice=$('#cmprice').text();

                $('#rp').html(cprice);
                $('#rpm').html(cprice);
                var price=cprice.substring(2,cprice.length);
                var pricelogo=cprice.substring(0,1);
                $('#latestprice').html(price);
                $('#latestpricelogo').html(pricelogo);
                localStorage.setItem("payment_type","corporate")
            });




        });
    }
    componentDidMount(){
        this.onload();
    }
}

export default ContentRightPrice;






// WEBPACK FOOTER //
// ./src/report-description/content/content-right/content-right-price/content-right-price.js